// Snapshot branding belongs to the MSP tenant, not the customer organization.
export const getSnapshotName = (tenantName) => {
  const name = typeof tenantName === 'string' ? tenantName.trim() : '';
  return `${name || 'Pipsqueak'} Snapshot`;
};
